import { useEffect } from 'react';
import { AlertCircle, CheckCircle2, X } from 'lucide-react';

interface ToastProps {
  message: string;
  type?: 'error' | 'success';
  onDismiss: () => void;
  autoDismissMs?: number;
}

export function Toast({ message, type = 'error', onDismiss, autoDismissMs = 3000 }: ToastProps) {
  useEffect(() => {
    const t = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(t);
  }, [message, onDismiss, autoDismissMs]);

  const Icon = type === 'success' ? CheckCircle2 : AlertCircle;
  const colorClass = type === 'success' ? 'bg-emerald-600' : 'bg-red-600';

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[min(420px,calc(100vw-2rem))]">
      <div className={`${colorClass} text-white rounded-xl shadow-lg px-4 py-3 flex items-start gap-2.5`}>
        <Icon size={18} className="shrink-0 mt-0.5" />
        <span className="text-sm flex-1">{message}</span>
        <button onClick={onDismiss} className="shrink-0 opacity-80 hover:opacity-100">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
